module.exports = __webpack_public_path__ + "media/images/athletes/3445-2265491f9a25f5bfa32e7cb16662cdc7.png";